import { takeEvery, fork, put, all, call } from 'redux-saga/effects';
import cogoToast from 'cogo-toast';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import {
  GET_BOOKING_MODIFICATION_FACILITIES,
  GET_BOOKING_MODIFICATION_FACILITIES_SUCCESS,
  GET_BOOKING_MODIFICATION_FACILITIES_ERROR,
} from '../../actions.js';
import apiCall from '../../../apiCall.js';

/* Only called for booking types marked facility-changeable — the others return 422. No auth required:
   it's a static facilities master with no customer data. */
function* getBookingModificationFacilities({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/admin/booking-modification/facilities/${payload?.bookingTypeId}`,
      method: 'GET',
      headers: { ...filteredHeaders },
    });

    if (response.status === 200) {
      yield put({
        type: GET_BOOKING_MODIFICATION_FACILITIES_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message || 'Unable to fetch facilities'}`);
      yield put({
        type: GET_BOOKING_MODIFICATION_FACILITIES_ERROR,
        payload: response?.response?.data?.message,
      });
    }
  } catch (error) {
    cogoToast.error('Unable to fetch facilities');
    yield put({ type: GET_BOOKING_MODIFICATION_FACILITIES_ERROR, payload: error });
  }
}

export function* watchGetBookingModificationFacilities() {
  yield takeEvery(GET_BOOKING_MODIFICATION_FACILITIES, getBookingModificationFacilities);
}

function* getBookingModificationFacilitiesSaga() {
  yield all([fork(watchGetBookingModificationFacilities)]);
}

export default getBookingModificationFacilitiesSaga;
